export const SET_LOADING = "SET_LOADING";
export const DISABLED_NUMBERS = "DISABLED_NUMBERS";
export const SET_CART = "SET_CART";
export const SET_GUID = "SET_GUID";

export const setLoading = (loading) => {
  return {
    type: SET_LOADING,
    payload: loading,
  };
};

export const setDisabledNumbers = (disabledNumbers) => {
  return {
    type: DISABLED_NUMBERS,
    payload: {
      disabledNumbers,
    },
  };
};

export const setCart = (cart) => {
  return {
    type: SET_CART,
    payload: {
      cart,
    },
  };
};

export const setGUID = (GUID) => {
  return {
    type: SET_GUID,
    payload: {
      strGuidWeb: GUID,
    },
  };
};



// WEBPACK FOOTER //
// ./src/reducers/rifa/rifaActions.js